import { useContext, useEffect, useRef } from "react";

import { useSearchParams } from "react-router-dom";

import { FloatingWindowsContext } from "src/base-components/FloatingWindow/context";
import { useFloatingWindowsActions } from "src/base-components/FloatingWindow/hooks";
import { FloatingWindowType } from "src/base-components/FloatingWindow/store";

const CASE_WINDOW_TYPES: FloatingWindowType[] = [
  "cm-action",
  "cm-history",
  "cm-file",
];

export const CaseWindowManager: React.FC = () => {
  const { close } = useFloatingWindowsActions();
  const store = useContext(FloatingWindowsContext);
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "tasks";
  const prevTabRef = useRef(currentTab);

  useEffect(() => {
    if (prevTabRef.current !== currentTab) {
      // Close unpinned case windows when switching tabs
      if (store) {
        const currentWindows = store.getState().windows;
        Object.values(currentWindows).forEach((window) => {
          if (CASE_WINDOW_TYPES.includes(window.type) && !window.isPinned) {
            close(window.id);
          }
        });
      }
    }
    prevTabRef.current = currentTab;
  }, [currentTab, close, store]);

  return null;
};
